export default __webpack_public_path__ + "static/media/work_place.14498b96.svg";